import { useContext, useEffect } from 'react';

import ErrorContext from '../errorContext';

const useTechnicalError = (error: any) => {
    // @ts-expect-error TS2339: Property 'setError' does not exist on type ''.
    const { setError } = useContext(ErrorContext);
    useEffect(() => {
        if (error) {
            setError();
        }
    }, [error, setError]);
};

export default useTechnicalError;
